import Image from "next/image";
import { cn } from "@/lib/utils";

type BrandLogoProps = {
  size?: "sm" | "md" | "lg";
  className?: string;
};

export default function BrandLogo({ size = "md", className }: BrandLogoProps) {
  const sizes = {
    sm: "h-9 w-28",
    md: "h-11 w-36",
    lg: "h-14 w-44",
  };

  return (
    <span className={cn("relative block shrink-0 overflow-hidden rounded-[var(--radius-sm)] bg-[var(--surface)]", sizes[size], className)}>
      <Image
        src="/corely-logo.png"
        alt="corely"
        fill
        priority={size !== "sm"}
        unoptimized={true}
        sizes="(max-width: 768px) 112px, 176px"
        className="object-contain"
      />
    </span>
  );
}
